module.exports = __webpack_public_path__ + "img/曲靖市妇幼保健院.d661ca80.png";